import { render, staticRenderFns } from "./addselfgroup.vue?vue&type=template&id=489dc4dc&scoped=true"
import script from "./addselfgroup.vue?vue&type=script&lang=js"
export * from "./addselfgroup.vue?vue&type=script&lang=js"
import style0 from "./addselfgroup.vue?vue&type=style&index=0&id=489dc4dc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489dc4dc",
  null
  
)

export default component.exports